import { render } from "./ChevronLeftSvg.vue?vue&type=template&id=982d0c02"
import script from "./ChevronLeftSvg.vue?vue&type=script&lang=js"
export * from "./ChevronLeftSvg.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1008117636/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__